// UI micro-copy only — navigation and content come from WordPress (Polylang + ACF)
// Covers: button labels, form messages, aria-labels, generic UI text
//
// ACSolar ships Portuguese only — see SHIPPING_LANGUAGES in gatsby-node.js.
// To add a language: add a block here keyed by its uppercase Polylang code,
// then register that code in SHIPPING_LANGUAGES and LANG_META.

const t = {
  PT: {
    header: {
      quote: "Pedir Orçamento",
      quoteFree: "Pedir Orçamento Gratuito",
      menu: "Menu",
      close: "Fechar",
      openMenu: "Abrir menu",
      closeMenu: "Fechar menu",
      whatsapp: "Falar por WhatsApp",
      backToTop: "Voltar ao topo",
    },
    footer: {
      tagline: "Energia inteligente. Poupança para o futuro.",
      navigation: "Navegação",
      solutions: "Soluções",
      contact: "Contactos",
      phone: "Telefone",
      whatsapp: "WhatsApp",
      email: "Email",
      copyright: "AC Solar. Todos os direitos reservados.",
      privacy: "Política de Privacidade",
      terms: "Termos e Condições",
      complaints: "Livro de Reclamações",
    },
    form: {
      submit: "Enviar mensagem",
      submitting: "A enviar...",
      successTitle: "Mensagem enviada!",
      successBody:
        "Obrigado pelo seu contacto. Entraremos em contacto consigo em breve.",
      sendAnother: "Enviar outra mensagem",
      error: "Ocorreu um erro. Por favor tente novamente.",
      required: "Este campo é obrigatório",
    },
    common: {
      readMore: "Ler mais",
      back: "Voltar",
      close: "Fechar",
      loading: "A carregar...",
      learnMore: "Saber mais",
    },
    nav: {
      soon: "Brevemente",
    },
  },
}

// Helper: get translations for a Polylang code. Only PT is shipped, so every
// lookup falls back to it; non-PT pages are not built (gatsby-node.js).
export const useT = (lang) => {
  const code = lang?.toUpperCase() || "PT"
  return t[code] || t["PT"]
}

export default t
